import { normalizeSearchText } from './searchText.js';

export const ARCHIVE_SEARCH_INDEX_SCOPES = Object.freeze({
  ALL: 'all',
  ARCHIVE: 'archive',
});

export function normalizeArchiveSearchIndexScope(scope = ARCHIVE_SEARCH_INDEX_SCOPES.ARCHIVE) {
  return scope === ARCHIVE_SEARCH_INDEX_SCOPES.ALL
    ? ARCHIVE_SEARCH_INDEX_SCOPES.ALL
    : ARCHIVE_SEARCH_INDEX_SCOPES.ARCHIVE;
}

export function normalizeArchiveSourceLabel(sourceLabel = '') {
  return String(sourceLabel || '').trim() || 'archive';
}

export function isArchiveScopedShow(show = {}) {
  return normalizeArchiveSourceLabel(show.sourceLabel) === 'archive';
}

function slugifyTag(tag = '') {
  return normalizeSearchText(tag).replace(/\s+/g, '-');
}

export function buildArchiveScopedTags(shows = [], fallbackTags = []) {
  const fallbackByLabel = new Map(
    (Array.isArray(fallbackTags) ? fallbackTags : [])
      .filter((tag) => tag?.tag)
      .map((tag) => [normalizeSearchText(tag.tag), tag])
  );
  const counts = new Map();

  for (const show of shows) {
    for (const tag of show.tasteTags || []) {
      const normalized = normalizeSearchText(tag);
      if (!normalized) {
        continue;
      }
      const fallback = fallbackByLabel.get(normalized) || {};
      const current = counts.get(normalized) || {
        tag: fallback.tag || tag,
        slug: fallback.slug || slugifyTag(tag),
        count: 0,
      };
      counts.set(normalized, {
        ...current,
        count: current.count + 1,
      });
    }
  }

  return [...counts.values()]
    .sort((left, right) => right.count - left.count || left.tag.localeCompare(right.tag));
}

export function filterArchiveSearchIndexForScope(index = {}, scope = ARCHIVE_SEARCH_INDEX_SCOPES.ARCHIVE) {
  const normalizedScope = normalizeArchiveSearchIndexScope(scope);
  if (normalizedScope === ARCHIVE_SEARCH_INDEX_SCOPES.ALL) {
    return {
      ...index,
      scope: ARCHIVE_SEARCH_INDEX_SCOPES.ALL,
    };
  }

  const shows = (Array.isArray(index.shows) ? index.shows : [])
    .filter(isArchiveScopedShow)
    .map((show) => ({
      ...show,
      sourceLabel: normalizeArchiveSourceLabel(show.sourceLabel),
    }));

  return {
    ...index,
    scope: ARCHIVE_SEARCH_INDEX_SCOPES.ARCHIVE,
    shows,
    tags: buildArchiveScopedTags(shows, index.tags),
  };
}
